/**
 * Single source of truth for public catalogue turntable behaviour.
 *
 * Used by:
 * - `publicRenderPipelines` (ModelViewer product + hero defaults)
 * - `productStageLayout` (prototype product profile)
 * - `StageTurntableCapture` / `HeroVase` product interaction
 *
 * On main-site integration: wire customiser + product blocks to the same renderer
 * and these constants — do not fork drag speed or auto-rotate in a second place.
 */
export const CATALOG_TURNTABLE = {
  interactionMode: 'turntable' as const,
  /** Horizontal drag — radians per pixel. */
  dragYawSensitivity: 0.005,
  /** Slow spin after release (rad/s). Pauses while dragging. */
  autoRotateSpeed: 0.38,
  autoRotateDirection: 1 as const,
  autoRotateModel: true,
  /** Public UX: yaw only — no vertical camera tilt. */
  tiltMaxDeg: 0,
  tiltSensitivity: 0.003,
  tiltResetOnRelease: true,
};

/** Holding / hero pipeline — look-first slow spin (backdrop often non-interactive). */
export const HERO_STUDIO_SPIN = {
  interactionMode: 'turntable' as const,
  dragYawSensitivity: CATALOG_TURNTABLE.dragYawSensitivity,
  autoRotateSpeed: 0.08,
  autoRotateDirection: CATALOG_TURNTABLE.autoRotateDirection,
  autoRotateModel: true,
  tiltMaxDeg: CATALOG_TURNTABLE.tiltMaxDeg,
  tiltSensitivity: CATALOG_TURNTABLE.tiltSensitivity,
  tiltResetOnRelease: CATALOG_TURNTABLE.tiltResetOnRelease,
};
